module.exports = __webpack_public_path__ + "static/media/logo-en.79ca2526.svg";